export class JobApplicationResume {
    public fileGUID: string = '';
    public reference: string = '';
}
